import { TextCell } from '@common/components/TextCell';

interface VehicleInterestsCellProps {
	vehicleInterests: {
		summaryLabel: string;
		models: string[];
	};
}

export const VehicleInterestsCell = ({ vehicleInterests }: VehicleInterestsCellProps) => {
	const display = vehicleInterests.summaryLabel;
	return <TextCell value={display} />;
};
